import React from "react";

/** Fills an image box for a row that has no image. */
const NoImagePlaceholder = ({ isDarkMode, iconClassName = "w-5 h-5" }) => (
  <div className={`w-full h-full flex items-center justify-center ${isDarkMode ? "text-gray-600" : "text-gray-400"}`}>
    <svg className={iconClassName} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  </div>
);

export default NoImagePlaceholder;
